export default "__VITE_ASSET__DgQ5rrwQ__"